(function(){
    angular
        .module('appback')
        .directive('ngCalendario', calendario);

        calendario.$inject = ['$timeout'];
        function calendario($timeout){
            return {
            templateUrl:'/backend/app/views/calendario.html',
            scope: { url:"=", control : "=" },
            //require: 'ngModel',
            link: function (scope, element, $attrs, ngModel) {
                return $timeout(function () {
                	console.log(scope);
                    scope.eventSource = [{
                            url: scope.url,
                            className: 'gcal-event',           // an option!
                            //currentTimezone: 'America/Chicago' // an option!
                    }];


                    scope.uiConfig = {
                      calendar:{
                        plugins: [ 'list' ],
                        //height: 450,
                        editable: true,
                        header:{
                          left: 'title',
                          center: 'month basicWeek agendaDay',
                          right: 'today prev,next'
                        },
                        buttonText:{
                          today:    'hoy',
                          month:    'Mensual',
                          agendaWeek:     'Semanal',
                          basicWeek: 'Semanal',
                          agendaDay : 'Diario',
                          day:      'day',
                        },
                        /*views: {
                          listDay: { buttonText: 'list day' },
                          listWeek: { buttonText: 'list week' },
                          listMonth: { buttonText: 'list month' }
                        },*/
                        firstDay:1,
                        eventClick: function(date, jsEvent, view){
                        	//console.log(date);
                        	//console.log(jsEvent);
                        	//console.log(view);
                            scope.initPopup(date);
                            //console.log(date.id);
                        },
                        contentHeight:"auto",
                        handleWindowResize:true,
                        themeSystem:'bootstrap3',
                        eventDrop: scope.calendarClick,
                        eventResize: scope.calendarClick,
                        eventRender: scope.calendarClick,
                        viewRender: function(view, element) {
                            //$log.debug("View Changed: ", view.visStart, view.visEnd, view.start, view.end);
                        },
                        timeFormat: 'H(:mm)' // uppercase H for 24-hour clock
                      }
                    };

                    scope.initPopup = function(date){
                    	//console.log(scope.cc);
                    	scope.control.initPopup(date.type,date.id,0,0,null);
                    	//console.log(id);
                    }

                    scope.calendarClick = function( date, jsEvent, view){
                        /*console.log(date);
                        console.log(jsEvent);
                        console.log(view);*/
                    }
                   
                });
            }
          }
      }
})();